Ext.define('SA.VectorMapExportParams', {
    singleton: true,

    forInsetMap({details, extent, pageWidth}) {
        var record = details.getInsetMap();

        return {extent, visible: record.isVisible(), x: record.getX(), y: record.getY(), ...this.getSize(record, {pageWidth})};
    },

    forLegend({details, modelState, pageWidth}) {
        var record = details.getLegend(),
            backgroundColor = {dark: '#444', light: '#fff'}[record.getTheme()],
            fontColor = {dark: '#fff', light: '#2a3651'}[record.getTheme()],
            visible = record.isVisible(),
            x = record.getX(),
            y = record.getY();

        return {backgroundColor, fontColor, modelState, visible, x, y, ...this.getSize(record, {pageWidth})};
    },

    forNorthArrow({details, pageWidth}) {
        var record = details.getNorthArrow();

        return {visible: record.isVisible(), x: record.getX(), y: record.getY(), ...this.getSize(record, {pageWidth})};
    },

    forScaleBar({details, extent, modelState, pageWidth}) {
        var record = details.getScaleBar(),
            mapWidth = this.getSize(details.getMap(), {pageWidth}).width,
            maxWidth = this.getSize(record, {pageWidth}).width,
            visible = record.isVisible(),
            x = record.getX(),
            y = record.getY();

        return {extent, mapWidth, maxWidth, modelState, visible, x, y};
    },

    forTextLabel({details, record}) {
        return {
            backgroundColor: record.getBackground(),
            fontColor: record.getColor(),
            fontFamily: record.getTypeface(),
            fontSize: record.getSizeInPixels(details.dpi),
            isBold: record.isBold(),
            isItalic: record.isItalic(),
            isUnderline: record.isUnderline(),
            text: record.getText(),
            x: record.getX(),
            y: record.getY()
        };
    },

    forThematicMap({details, extent, modelState, pageWidth}) {
        var record = details.getMap(),
            x = record.getX(),
            y = record.getY();

        return {extent, modelState, x, y, ...this.getSize(record, {pageWidth})};
    },

    get({details, modelState, pageHeight = details.getHeight(), pageWidth = details.getWidth()}) {
        var extent = SA.VectorMapExtent.fromXYBounds(details.getExtent().getBounds());

        return {
            insetMap: this.forInsetMap({details, extent, pageWidth}),
            legend: this.forLegend({details, modelState, pageWidth}),
            northArrow: this.forNorthArrow({details, pageWidth}),
            pageHeight,
            pageWidth,
            scaleBar: this.forScaleBar({details, extent, modelState, pageWidth}),
            textLabels: details.getTextLabels().map(record => this.forTextLabel({details, record})),
            thematicMap: this.forThematicMap({details, extent, modelState, pageWidth})
        };
    },

    getSize(record, {pageWidth}) {
        var width = record.getWidth() * pageWidth,
            height = record.getAspectRatio() * width;

        return {width, height};
    }
});